import React from 'react';
import * as styles from './logo.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var HLogo = _ref => {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return ___EmotionJSX("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    viewBox: "0 0 144 144"
  }, ___EmotionJSX("path", {
    css: styles.primaryColourPath,
    fill: "currentColor",
    d: "M20 0h104c11.08 0 20 8.92 20 20v104c0 11.08-8.92 20-20 20H20c-11.08 0-20-8.92-20-20V20C0 8.92 8.92 0 20 0z"
  }), ___EmotionJSX("path", {
    css: styles.whiteColourPath,
    fill: "currentColor",
    d: "M99.718 71.627l-27.72-18.092-10.206 6.64v-26.64L44.282 22v100h17.51V80.838L72 74.116l10.373 6.805v40.75h17.345V71.63z"
  }));
};
export default HLogo;